
<template>
  <div>
    <div class="inner-wrap px-2">
      <!-- <InstructionBtn v-if="!isLoading" /> -->
      <CustomJobsPage
        class="mt-2 mb-4"
        :items="items"
        :num-of-jobs="numOfJobs"
        :empty-msg="emptyMsg"
        :isLoading="isLoading"
        :user-active="userActive"
        :showRank="true"
        :activeAgentsUrl="activeAgentsUrl"
      />
      <DrBtn
        v-if="!loading && nextPage > -1"
        type-btn="load_jobs_btn narrow mb-6"
        :action="loadMore"
        :loader="loading"
      >
        טען עוד
      </DrBtn>
      <Spinner v-if="loading" />
      <div v-if="!isLoading">
        <!-- <InstructionsDialog
          :page="'myboard'"
          :displayModal="ShowSmartAgentGuidMyBoard && SmartAgentActive"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import CustomJobsPage from '@/components/Candidates/Pages/CustomJobs/CustomJobsPage';
import Spinner from '@/components/Spinner/Spinner';
import CurrentUser from '@/components/mixins/CurrentUser';
import SeoOptimization from '@/components/mixins/SeoOptimization';
// import InstructionsDialog from '@/components/Dialogs/InstructionsDialog/InstructionsDialog';
// import InstructionBtn from '@/components/Japu/Instructions/InstructionBtn';
import { BOARD } from '@/lib/api.js';

export default {
  mixins: [CurrentUser, SeoOptimization],
  middleware: 'personalPage',
  layout: 'personal',
  name: 'MyBoardPage',

  components: {
    CustomJobsPage,
    Spinner,
    // InstructionsDialog,
    // InstructionBtn,
  },

  data() {
    return {
      loading: false,
      loadMoreBtn: false,
      items: [],
      numOfJobs: 0,
      nextPage: undefined,
      itemsCount: null,
      recommended: null,
      emptyMsg: '',
      seodata: null,
      generalDFP: {
        dfpID: '3177829/search_results_desktop',
        dfpSize: [925, 100],
      },
      mobileDFP: {
        dfpID: '3177829/search_results_mob',
        dfpSize: [320, 50],
      },

      activeAgentsUrl: null,
    };
  },

  computed: {
    areMoreJobs() {
      return this.numOfJobs > this.items.length;
    },

    userActive() {
      return this.SmartAgentActive;
    },
    isLoading() {
      return this.$fetchState.pending;
    },
  },

  mounted() {
    this.$nuxt.$emit('hideEditForm');
    window.scrollTo(0, 0);
    // listener for rank to remove jobs from numOfJobs
    this.$nuxt.$on('reduceNumOfJobs', this.reduceNumOfJobs);
  },

  beforeDestroy() {
    this.items = [];
    this.$nuxt.$off('reduceNumOfJobs');
  },

  async fetch() {
    const { agentscodes } = this.$route.query;

    if (!agentscodes) {
      this.emptyMsg = true;
      return;
    }
    if (!process.server) this.$nuxt.$loading.start();

    this.activeAgentsUrl = parseInt(agentscodes);

    try {
      const { data } = await this.$axios.get(
        `${BOARD}?agentsCodes=${agentscodes ? agentscodes : ''}`
      );

      if (data.IsError) {
        throw data.Errors;
      }

      this.items = data.ResultList;
      this.nextPage = data.NextPageNumber;
      this.numOfJobs = data.TotalSearchResultCount;
      this.itemsCount = data.Count;
      this.recommended = data.RecommendedJobs;
      this.emptyMsg = data.ResultList.length === 0;
      this.seodata = {
        metaData: data.SEO.MetaDataItems,
        pageTitle: data.SEO.title,
        canonicalUrl: data.SEO.canonicalUrl,
      };
      if (!process.server) this.$nuxt.$loading.finish();
    } catch (error) {
      console.log('error', error);
    }
  },
  head() {
    return {
      title: this.seodata?.pageTitle,
      meta: this.seodata?.metaData,
      link: [{ rel: 'canonical', href: this.seodata?.canonicalUrl }],
    };
  },
  methods: {
    async loadMore() {
      if (this.nextPage != -1) {
        this.loading = true;

        const { data } = await this.$axios.get(
          `${BOARD}?page=${this.nextPage}&agentsCodes=${this.activeAgentsUrl}`
        );

        const nextItems = data.ResultList;
        const existedItems = this.items;
        const currResults = [...existedItems, ...nextItems];
        this.nextPage = data.NextPageNumber;
        this.items = currResults;
        this.loading = false;
      }
    },

    reduceNumOfJobs() {
      --this.numOfJobs;
    },
  },
  watch: {
    '$route.query': '$fetch',
  },
};
</script>

